/* What the home page says about each live game (owner, 2026-09-22: "a specific live games
section ... with the games that are started, with the round we're in and vs who"). Pure, so the
list can be tested without the page.

A row is one game this account is in — a seat still in the fight, or a spectator's eyes — and it
answers three things: which round it is on, who the account is up against (and with), and whether
the account still owes this round an END TURN. A seat that is out stays on the list, marked `out`
(owner, 2026-10-02): its allies fight on, the game view lets it watch them, and the history lists
only finished games, so leaving it off left a war the account is still in reachable from nowhere. */

export const liveGameRows = (games, userId) =>
  (games || [])
    .filter((game) => game && game.status !== "finished")
    .map((game) => {
      const seat = game.players?.find((player) => player.user.id === userId) ?? null
      const watching = !seat && Boolean(game.spectators?.some((watcher) => watcher.id === userId))
      if (!seat && !watching) return null
      const out = Boolean(seat?.eliminated)
      const others = (game.players || []).filter((player) => player.user.id !== userId)
      const opponents = seat ? others.filter((player) => player.team !== seat.team) : others
      const allies = seat ? others.filter((player) => player.team === seat.team) : []
      return {
        id: game.id,
        mode: game.mode,
        // The world it is played on (requirement 35, M12), "L" for a game from before the sizes.
        mapSize: game.mapSize ?? "L",
        round: game.tick,
        roundSeconds: game.roundSeconds,
        opponents: opponents.map((player) => player.user.username),
        allies: allies.map((player) => player.user.username),
        // Whether this seat still has to end its turn this round. A watcher has no turn, nor does
        // a seat that is out.
        yourTurn: Boolean(seat) && !out && !seat.ready,
        watching,
        out,
      }
    })
    .filter(Boolean)
